import React from 'react'
import bannerproimg from "../Images/Frame 2121450080.png";
import { Helmet } from "react-helmet-async";
import { motion } from "framer-motion";
import './ECommerce.css'
import listingimg1 from '../Images/Group 1171276767.png'
import projectpic1 from "../Images/image 588254101 (2).png";
import projectpic2 from "../Images/image 588254102 (3).png";
import projectpic3 from "../Images/image 588254103 (2).png";
import projectpic4 from "../Images/image (7).png";
import arrowpic from "../Images/www.lazarev.agency-7 1.svg";
import profileimg3 from "../Images/Muhammad Qasim 2 (1).png";




const fadeUpAnimation = {
    initial: { opacity: 0, y: 50 },
    whileInView: { opacity: 1, y: 0 },
    transition: { duration: 1, ease: "easeInOut" },
    viewport: { once: true, amount: 0.1 },
};

function ECommerce() {
    return (
        <div className="webdesign-main-div">
            <Helmet>
                <title>UI/UX Design - Portfolio</title>
            </Helmet>
            <div
                className="container-fluid ecom-banner-div11 "
            >
                <div className="container">
                    <div className="ecom-banner-text-div1">
                        <motion.h1
                {...fadeUpAnimation}h1>
                            eCommerce Creatives <br className='d-md-block d-none' />
                            That Drive <span>30% More Sales</span>
                        </motion.h1>
                        <motion.p
                {...fadeUpAnimation}>
                            From listing images to storefronts and A+ content I create visuals
                            <br className="d-md-block d-none" /> that help your brand stand out and sell more.

                        </motion.p>

                        <motion.div
                            {...fadeUpAnimation} className="ecom-book-call-web-design-btn text-center">
                            <a href="https://calendly.com/iamqasim/30min" target='_blank'>
                                <div>Book a Call →</div>
                            </a>
                        </motion.div>

                        <motion.div
                            {...fadeUpAnimation} className="ecom-banner-img-div">
                            <img src={bannerproimg} className='img-fluid' alt="" />
                        </motion.div>


                        <div>
                            <motion.div
                                {...fadeUpAnimation} className='row ecom-banner-cards-div1'>
                                <div className='col-lg-4'>
                                    <div className='ecom-banner-cards-div22'>
                                        <div>
                                            <h5>🎯</h5>
                                            <h2>Brand Impact</h2>
                                            <h6>Customers are visually stimulated, and <span>so are we!</span></h6>
                                        </div>
                                    </div>
                                </div>

                                <div className='col-lg-4'>
                                    <div className='ecom-banner-cards-div22'>
                                        <div>
                                            <h5>👁️</h5>
                                            <h2>Enhanced Visibility</h2>
                                            <h6>When it comes to online shopping - <span>looks are important.</span></h6>
                                        </div>
                                    </div>
                                </div>

                                <div className='col-lg-4'>
                                    <div className='ecom-banner-cards-div22'>
                                        <div>
                                            <h5>💰</h5>
                                            <h2>Conversion Power</h2>
                                            <h6>Images account for around  <span>75%
                                                of the purchase decision.</span></h6>
                                        </div>
                                    </div>
                                </div>
                            </motion.div>
                        </div>

                    </div>
                </div>
            </div>

            {/* Section ###### No : ---------- 2  */}

            <motion.div
                {...fadeUpAnimation} className='container-fuild ecom-help-div1'>
                <div className='container'>
                    <div className='ecom-help-text1-div1'>
                        <h1>
                            <span>What I</span> Can Help You With
                        </h1>
                        <p>
                            Strategic design that’s <span>focused on results.</span> Not just looks.

                        </p>

                        <div>
                            <div className='row ecom-help-card-row-div1'>
                                <div className='col-lg-4'>
                                    <div className='ecom-help-card-text-div1'>
                                        <div>
                                            <img src={listingimg1} />
                                        </div>
                                        <div>
                                            <h3>Listing Images</h3>
                                            <h6>Custom designed visuals for ecommerce platforms optimized for clarity, branding, and conversion.</h6>
                                        </div>
                                    </div>
                                </div>

                                <div className='col-lg-4'>
                                    <div className='ecom-help-card-text-div1'>
                                        <div>
                                            <img src={listingimg1} />
                                        </div>
                                        <div>
                                            <h3>EBC / A+ Content</h3>
                                            <h6>Modular content blocks that elevate your product pages ideal for Amazon and adaptable for websites too.</h6>
                                        </div>
                                    </div>
                                </div>

                                <div className='col-lg-4'>
                                    <div className='ecom-help-card-text-div1'>
                                        <div>
                                            <img src={listingimg1} />
                                        </div>
                                        <div>
                                            <h3> Branded Storefronts</h3>
                                            <h6>Immersive, conversion-optimized storefront designs that reflect your brand and boost shopper trust.</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div>
                            <div className="ecom-help-call-btn text-center">
                                <a href="https://calendly.com/iamqasim/30min" target='_blank'>
                                    <div>Level up your creatives →</div>
                                </a>
                            </div>
                            <p className='ecom-help-call-btn-text'>
                                Smart visuals. Better conversions. <span>Real results.</span>
                            </p>
                        </div>

                    </div>
                </div>
            </motion.div>






















            {/* Section ###### No : ---------- 4 */}

            <motion.div
                {...fadeUpAnimation}
                className="container-fluid webdesign-portfolio-sec-div1"
            >
                <div className="container">
                    <div className="portfolio-sec-text-div1">
                        <div>
                            <h1>
                                <span>Proven Results,</span> Trusted by Real Clients
                            </h1>
                            <p>
                                Design<span> that works</span> — beyond just looking good.
                            </p>
                        </div>
                        <div className="row">
                            <motion.div {...fadeUpAnimation} className="col-lg-6">
                                <div className="portfolio-sec-text-div2">
                                    <a href='https://myaccentway.com/' target="_blank">
                                        <div>
                                            <img src={projectpic1} className="img-fluid" alt="" />
                                        </div>
                                        <div className="portfolio-sec-text-div3">
                                            <div>
                                                <h2>My Accent Way</h2>
                                                <h6>Boosted trial sign-ups by 32% with CRO improvements.</h6>
                                            </div>
                                            <div>
                                                <img src={arrowpic} alt="" />
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </motion.div>

                            <motion.div {...fadeUpAnimation} className="col-lg-6">
                                <div className="portfolio-sec-text-div2">
                                    <a href='https://www.shinie.de/' target="_blank">
                                        <div>
                                            <img src={projectpic2} className="img-fluid" alt="" />
                                        </div>
                                        <div className="portfolio-sec-text-div3">
                                            <div>
                                                <h2>Shinie</h2>
                                                <h6>Improved AOV by 35% through mobile-first design.</h6>
                                            </div>
                                            <div>
                                                <img src={arrowpic} alt="" />
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </motion.div>

                            <motion.div {...fadeUpAnimation} className="col-lg-6">
                                <div className="portfolio-sec-text-div2">
                                    <a href='https://pkcargo.co.uk/' target="_blank">
                                        <div>
                                            <img src={projectpic3} className="img-fluid" alt="" />
                                        </div>
                                        <div className="portfolio-sec-text-div3">
                                            <div>
                                                <h2>Pk Cargo</h2>
                                                <h6>Cut bounce rate by 40% with streamlined navigation.</h6>
                                            </div>
                                            <div>
                                                <img src={arrowpic} alt="" />
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </motion.div>

                            <motion.div {...fadeUpAnimation} className="col-lg-6">
                                <div className="portfolio-sec-text-div2">
                                    <a href='https://zumwax.com/' target="_blank">
                                        <div>
                                            <img src={projectpic4} className="img-fluid" alt="" />
                                        </div>
                                        <div className="portfolio-sec-text-div3">
                                            <div>
                                                <h2>Zum Wax</h2>
                                                <h6>28% boost in conversions after optimizing user flow and product discovery.</h6>
                                            </div>
                                            <div>
                                                <img src={arrowpic} alt="" />
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </motion.div>
                        </div>
                    </div>
                </div>
            </motion.div>























             <motion.div
                    {...fadeUpAnimation}
                    className="container-fluid webdesign-choice-div1 pl-0 pr-0"
                  >
                    <div className="webdesign-choice-div2233">
                      <div className="container">
                        <div>
                          <div className="web-choice-sec-img-div1">
                            <img src={profileimg3} />
                          </div>
            
                          <div className="ecom-ready-sec-text-div">
                            <h1>
                                    <span > Ready to </span>
                                     🚀 level up <br className='d-md-block d-none'/>
                                    your Creatives
                            </h1>
                            <p>
                                    Smart visuals. Better conversions. <span>Real results.</span>
                            </p>
                          </div>
            
                          
                          <div className="ecom-ready-free-btn-12">
                            <a href="https://calendly.com/iamqasim/30min" target='_blank'>
                              <div>Request a Free Consultation</div>
                            </a>
                          </div>
            
                         
                        </div>
                      </div>
                    </div>
                  </motion.div>

        </div>
    )
}

export default ECommerce
